import { AuthService } from "./../services/auth.service";
import { Usuario } from "./../models/usuario.model";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-config",
  templateUrl: "./config.component.html",
  styleUrls: ["./config.component.scss"],
})
export class ConfigComponent implements OnInit {
  logoLoja: string;
  nomeLoja: string;
  emailLoja: string;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.nomeLoja = this.authService.usuario.Nome;
    this.logoLoja = this.authService.usuario.Logo;
    this.emailLoja = this.authService.usuario.Email;
  }
}
